$(document).ready(function () {
  
    // Blogs Load More  
    
    $(document).on('click', '.js-loadMore', function(event) {
        event.preventDefault();
        let url = $(this).attr('data-next-url');
        $.ajax({
            url: url,
            dataType: "html",
            beforeSend: function() {
              $(".blog .link_to button i").addClass('fa-refresh fa-spin fa-spinner');
              $(".blog .link_to button span").hide() ;
            }            
        })
        .done(function(data) {
            $(".blog .link_to button i").removeClass('fa-refresh fa-spin fa-spinner');
            let nextURL = $(data).find(".loadMore").attr('data-next-url');
            let pageSize = $(data).find(".loadMore").attr('data-page-size');
            let currentPage = $(data).find(".loadMore").attr('data-current-page');
            $(".blog .group").append($(data).find('.group .blog_item'));
            $(".blog .link_to").find(".loadMore").attr('data-next-url',nextURL);
            $(".blog .link_to").find(".loadMore").attr('data-page-size',pageSize);
            $(".blog .link_to").find(".loadMore").attr('data-current-page',currentPage);
          $(".blog .link_to button span").show() ;
            if(!nextURL) {
                $(".blog .link_to").hide();
            }else{
                $(".blog .link_to").show();
            }
        })
    });
       
  
  
    $(window).scroll(function () {
      	
        $('.pricing_list .tab_content .tab_box').each(function () {

            var wScroll = $(window).scrollTop();
            var cScroll = $(this).offset().top  - ($(window).height() * .3);
          	var cScroll2 = $(this).offset().top + $(this).height()  - ($(window).height() * .3);
			
            if (wScroll > cScroll && wScroll < cScroll2) {
              
                $(this).addClass('active').siblings().removeClass('active');
//                 $('.pricing_list .list_content ul li').eq($('.pricing_list .tab_content .tab_box').hasClass('active').index()).addClass('active');
              
            }
        });
      
      	
      $('.pricing_list .tab_content .tab_box.active').each(function () {
      	
			var wScroll = $(window).scrollTop();
            var cScroll = $(this).offset().top  - ($(window).height() * .3);
          	var cScroll2 = $(this).offset().top + $(this).height()  - ($(window).height() * .3);
			
            if (wScroll > cScroll && wScroll < cScroll2) {
              
                $('.pricing_list .list_content ul.select li').eq($(this).index()).addClass('active').siblings().removeClass('active');
              
            }
      })
	
    });
      
    // Animation Attribute Data Set

    $('[data-style*="riseUp"]').wrap('<div class="animation_cropper"><div class="crop_content"></div></div>');

    $('[data-style*="animation"]').each(function () {
        $delay = $(this).attr("data-delay");
        $duration = $(this).attr("data-duration");

        if ($delay === "") {

            $delay = 0.5 + "s";
            $(this).css({
                "animation-delay": $delay
            }).parents('.crop_content').css({
                "animation-delay": $delay
            }).children('[data-style*="animation"]').removeAttr('style');
            $(this).removeAttr('data-delay data-duration');

        } else {

            $delay = $delay + "s";
            $(this).css({
                "animation-delay": $delay
            }).parents('.crop_content').css({
                "animation-delay": $delay
            }).children('[data-style*="animation"]').removeAttr('style');
            $(this).removeAttr('data-delay data-duration');
        }
        if ($duration === "") {

            $duration = 0.5 + "s";
            $(this).css({
                "animation-duration": $duration
            }).parents('.crop_content').css({
                "animation-duration": $duration
            }).children('[data-style*="animation"]').removeAttr('style');
            $(this).removeAttr('data-delay data-duration');
        } else {

            $duration = $duration + "s";
            $(this).css({
                "animation-duration": $duration
            }).parents('.crop_content').css({
                "animation-duration": $duration
            }).children('[data-style*="animation"]').removeAttr('style');
            $(this).removeAttr('data-delay data-duration');
        }

    });

    // Animation Attrbute Data Controll End

    // Auto Animation Delay Stytem 


    $('[data-style*="animation-auto"]').each(function () {

        $delayCount = $(this).attr("data-delay-unit");

        $(this).children().each(function () {

            $selected = $(this).index();

            if ($delayCount === "") {

                $delayCount = 0.1;
                $selected = (($selected + 1) * $delayCount) + "s";
                $(this).css({
                    "animation-delay": $selected
                });
                $(this).children().css({
                    "animation-delay": $selected
                });

            } else {

                $delayCount = $delayCount;
                $selected = (($selected + 1) * $delayCount) + "s";
                $(this).css({
                    "animation-delay": $selected
                });
                $(this).children().css({
                    "animation-delay": $selected
                });
            }

        });

        $(this).removeAttr('data-delay-unit');

    });

    // Auto Animation Fix Duration Method


    $('[data-style*="fix-duration"]').each(function () {

        $fixDuration = $(this).attr("data-duration-unit");

        if ($fixDuration === "") {

            $fixDuration = 1 + "s";
            $(this).children().css({
                "animation-duration": $fixDuration
            });
            $(this).children('.animation_cropper').removeAttr('style').children().css({
                "animation-duration": $fixDuration
            });

        } else {

            $fixDuration = $fixDuration + "s";
            $(this).children().css({
                "animation-duration": $fixDuration
            });
            $(this).children('.animation_cropper').removeAttr('style').children().css({
                "animation-duration": $fixDuration
            });

        }

        $(this).removeAttr('data-duration-unit');

    });

    // Sticky Header Fix

    $('[data-style*="sticky"]').wrap('<div class="sticky_nav"></div>');

    $hader_hight = $(".header_navbar").height();

    $(window).scroll(function () {

        if ($(window).scrollTop() < 10) {
            $hader_hight = $('[data-style*="sticky"]:not(.open)').height();
            $(".sticky_nav").height($hader_hight);
        }

        if ($(window).scrollTop() > 10) {
            $('[data-style*="sticky"]').addClass("active");
            setTimeout(addOpen, 100);

            function addOpen() {

                $('[data-style*="sticky"]').addClass("open");
            }
        } else {

            $('[data-style*="sticky"]').removeClass("active");
            $('[data-style*="sticky"]').removeClass("open");
        }

    })


    $(window).resize(function () {
        $hader_hight = $('[data-style*="sticky"].open').height();
        $(".sticky_nav").height($hader_hight);

        if ($(window).scrollTop() < 10) {
            $hader_hight = $('[data-style*="sticky"]:not(.open)').height();
            $(".sticky_nav").height($hader_hight);
        }
    })

    // Sticky Nav Fixed


    // Any type of toggle popup add and remove class open

//     $('body header').prepend('<span class="screen" ></span>');

    $('[data-toggle*="open"]').click(function (e) {
        e.preventDefault();
        $selector_button = $(this).attr("data-target");
        $selected_content = $('[data-toggle*="content"]').attr("data-target");

        if ($selector_button == $selected_content) {
            $('[data-toggle*="content"]').toggleClass('open')
        }

        $('[data-toggle*="close"]').toggleClass('open');
        $(".screen").toggleClass("open");
        $("body").css("overflow", "hidden");

    });

    $('[data-toggle*="close"]').click(function (e) {
        e.preventDefault();
        $selector_button = $(this).attr("data-target");
        $selected_content = $('[data-toggle*="content"]').attr("data-target");

        if ($selector_button == $selected_content) {
            $('[data-toggle*="content"]').removeClass('open')
        }

        $(this).toggleClass('open');
        $(".screen").toggleClass("open");
        $("body").css("overflow", "auto");

    });

    $('[class*="screen"]').click(function (e) {
        e.preventDefault();
        $('[data-toggle*="content"]').removeClass('open')
        $('[data-toggle*="close"]').toggleClass('open');
        $(".screen").toggleClass("open");
        $("body").css("overflow", "auto");
    });


    $('.tab_list ul li').click(function (e) {
        e.preventDefault();
        $(this).addClass('active').siblings().removeClass('active');
        $('.category_items .tab_content .tab_item').eq($(this).index()).addClass('active').siblings().removeClass('active');
    })

    $('.list_content ul.select li').click(function (e) {
        e.preventDefault();
        $(this).addClass('active').siblings().removeClass('active').parents().removeClass('active');
        $('.tab_content .content_wrap .tab_box').eq($(this).index()).addClass('active').siblings().removeClass('active');
        $('.list_content ul.current').empty().append($(this).clone());
      
        var scrollToThe = $('.pricing_list .tab_content .tab_box').eq($(this).index()).offset().top  - ($(window).height() * .18);
        $('html, body').animate({
            scrollTop: scrollToThe,
        }, 'slow');

    })
    
    $('#hamburger_pick').click(function (e) {
        e.preventDefault();
        $(this).toggleClass('active');
      	$('.mobile_menu').toggleClass('open');
      	$('.sticky_nav').toggleClass('deactive');

    })

    $('.close-popup').click(function (e) {
        e.preventDefault();
        $(this).parents('.popup-message').removeClass('active');

    })
    
    $('.popup-message .body_close').click(function () {
        $('.popup-message.active').removeClass('active');

    })
    
    
    $('.quote_button').click(function (e) {
        e.preventDefault();
        $('.popup-message').addClass('active');

    })
    
    $('.pricing_list .tab_content .tab_box a').click(function (e) {
        e.preventDefault();
//         $('.popup-message').addClass('active');

    })
        

    $('.list_content ul.current').click(function (e) {
        e.preventDefault();
        $(this).siblings('ul').toggleClass('active');
    })

    $('.accordion ul li .body').slideUp();
    $('.accordion ul li .head').click(function () {
        $(this).toggleClass('active').siblings().slideToggle();
    });


    $(".details ul li input").focus(function () {
        $(this).parents('li').addClass('active');
    });

    $(".details ul li input").blur(function () {
        $(this).parents('li').removeClass('active');
    });
  
      $(".blog .blog_item").mouseenter(function (e) {
        e.preventDefault();
        $(this).addClass('animate-op');
    });
  
    $(".blog .blog_item").mouseleave(function (e) {
        e.preventDefault();
        $(this).removeClass('animate-op');
    });
  
  $(".language_popup ul.select-list").hide();
    $(".language_popup ul.selected").click(function(e) {
        e.preventDefault();
        $(".language_popup ul.select-list").show();
    });

    $(".language_popup ul.select-list li").click(function(e) {
        $(".language_popup ul.select-list").hide();
        var copy = $(this).clone();
        $(".language_popup ul.selected li").empty().append(copy);
    });
  

    // Any type of toggle and popup and add and remove class open



    jarallax(document.querySelectorAll(".jarallax"));

    $(".currency ul li").click(function (e) {
        e.preventDefault();
        $(".selact_item").toggleClass("open");
    });

    $(".selact_item ul li").click(function () {
        var currentele = $(this).html();
        $(".default ul li").html(currentele);
        $(".selact_item").removeClass("open");
    });

    $(".color_swatch .swatch_list li").mouseenter(function (e) {
        e.preventDefault();
        $(this)
            .parents(".product_item")
            .find(".coloured_img")
            .eq($(this).index())
            .css({
                "z-index": "1",
                opacity: "1"
            })
            .siblings()
            .css("z-index", "-1");
    });
    $(".color_swatch .swatch_list li").mouseleave(function (e) {
        e.preventDefault();
        $(this).parents(".product_item").find(".coloured_img").attr("style", "");
    });
  

});

$(".announcement_slider").slick({
    dots: false,
    arrows: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
});

$(".hero_slider").slick({
    dots: true,
    arrows: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    fade: true,
    pauseOnHover: false,
    // cssEase: 'linear'
});

$(".product_slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    asNavFor: ".thumbnail_slider",
});

$(".thumbnail_slider").each(function () {
    $(this).slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        asNavFor: ".product_slider",
        dots: false,
        arrows: false,
        focusOnSelect: true,
    });
});

$(".top_seller_slider").each(function () {
    var next = $(this).siblings(".next_arrow");
    var prev = $(this).siblings(".prev_arrow");
    $(this).slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        nextArrow: next,
        prevArrow: prev,
        responsive: [{
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            }
        ]
    });
});

    
var swiper = new Swiper('.pricing_slider', {
  // Default parameters
  slidesPerView: 1,
  spaceBetween: 10,
  // Responsive breakpoints
  breakpoints: {
    // when window width is >= 320px
    400: {
      slidesPerView: "auto",
  	  spaceBetween: 22
    }
  }
})


if(!Shopify){
  Shopify = {};
}
Shopify.names = [] ;





function uiqueobject(objects){
  var unique = [] ;
  var l = objects.length
  for( i=0; i<l; i++) {
    if(Shopify.names.includes(objects[i].name) == false ){
      Shopify.names.push(objects[i].name)
      unique.push(objects[i])
    }
  }  
  return unique 
}


function uiqueremoveobject(fileName){

  
  const index = Shopify.names.indexOf(fileName);
  if (index > -1) {
    Shopify.names.splice(index, 1); // 2nd parameter means remove one item only
  }
  console.log(Shopify.names)
  return Shopify.names 
}



if(true){
  var SELECTED_FILES = [];
  $('input#myFile').change(function(e) {
    var _self = this
    $("#Seven-files-text").show(); 
    console.log(e);
    var length = e.target.files.length;
    let fragment="";
    if (SELECTED_FILES.length <= 5) {
      for(var i = 0 ; i < 5; i++) {
        console.log(SELECTED_FILES.length)
        let file = e.target.files[i];
        if(!file){
          continue;
        }
        if(SELECTED_FILES.length == 5){
          e.target.disabled = "true";
          $(_self).attr('disabled','disabled')
          break;
        }
        if(toKbs(file.size) >10000 ){
          alert(`${file.name} - File size cant greater then 10mb`);
          continue;
        }
        if(Shopify.names.includes(file.name)  ) {continue} 
        SELECTED_FILES.push(file);
        uiqueobject(SELECTED_FILES)

        fragment = fragment.concat(createFileInfoContainer(file));

        if(SELECTED_FILES.length == 5){
          e.target.disabled = "true";
        }
      }

      $("#Selected_files").append(fragment);
      $("#Selected_files .file_info_container").unbind("click");
      $("#Selected_files .file_info_container .remove_item_btn").bind("click",function(){
        let fileName = $(this).parent().find('.file_name').attr('file_name').trim();
        removeFile(fileName);
        uiqueremoveobject(fileName)
      });
    } else {
      $(_self).attr('disabled','disabled')
       e.target.disabled = "true";
    }
    $(".select_file_count").text(SELECTED_FILES.length);
    
    
    $('.image_and_count-box').removeClass(`items_1_added items_2_added items_3_added items_4_added items_5_added`)
    $('.image_and_count-box').addClass(`items_${SELECTED_FILES.length}_added`)
    
  });

  function removeFile(fileName) {
    let fileName$ = $('#Selected_files .file_info_container .file_name');
    

    
    
    let selectedFile$;
    fileName$.each(function() {
      if($(this).attr('file_name') == fileName) {
        selectedFile$ = $(this);
      }
    });

    if(selectedFile$) {
      selectedFile$.parent().remove();
    }
    SELECTED_FILES = SELECTED_FILES.filter(f=>f.name != fileName);
    $('input#myFile')[0].disabled = "";
    $('input#myFile').val(null);
    $(".select_file_count").text(SELECTED_FILES.length);
    
    $('.image_and_count-box').removeClass(`items_1_added`)
    $('.image_and_count-box').removeClass(`items_2_added`)
    $('.image_and_count-box').removeClass(`items_3_added`)
    $('.image_and_count-box').removeClass(`items_4_added`)
    $('.image_and_count-box').removeClass(`items_5_added`)
    $('.image_and_count-box').addClass(`items_${SELECTED_FILES.length}_added`)
    
  }

  function createFileInfoContainer(file){
    return`
<div class="file_info_container tooltip">
  <span class="tooltiptext">${file.name.trim()}</span>
<span class="remove_item_btn"><i class="fal fa-times"></i></span>
<span class="file_name" file_name="${file.name}" >${truncate(file.name.trim(),10)} ${getExtension(file.name)}</span>
<span class="file-extenction">
${fileSize(file.size)} - ${getExtension(file.name)}
</span>
</div>   
`;        
  }

  function truncate(data,offset = 10){
    if(data) {
      return data.substring(0, offset) + '...';
    }
  }
  function removeExtension(text) {
    if(text){
      return text.split(".")[0].trim();
    }
  }

  function getExtension(text) {
    if(text){
      return text.split(".")[text.split(".").length-1].trim();
    }
  }

  function toKbs(bSize) {
    console.log(bSize)
    if(bSize){
      let toa = (bSize/1000).toFixed(0)
      return `${toa}`;
    }
  }
    function fileSize(bSize) {
    console.log(bSize)
    if(bSize){
      let kbSize = (bSize/1000).toFixed(0)

      let mbSize = (kbSize/1000).toFixed(1);

      if(mbSize > 1){
        return `${mbSize} mb`;
      }
      else{
        return `${kbSize} kb`
      }


    }
  }

}

$(".js_postal_code input").on('keyup',function(e){
  if(/^[0-9]*$/.test(e.originalEvent.key)) {
    $(this).val('');
    $(this).val(e.originalEvent.key);
    let postalCode = $(".js_postal_code")
    .find("input")
    .map(function() {
      return this.value;
    }).get().join('');

    if(postalCode.length != '5'){
      $(this).parent().next().find('input').focus();
    }else{

      $(".shiping_found , .shiping_not_found").hide();
      if(window.postal_codes && window.postal_codes.split(',').some(d=> d == postalCode)) {
        $(".shiping_not_found").show();
      } else {
        $(".shiping_found").show();
      }

      $('ul.button_group.sp.js_postal_code').hide();
      $(".go_back_postal_code").show();
      $(".postal_code_status").hide();



    }
  }else if(e.which == 8){
    if( $(this).val() == '')
    {
      $(this).parent().prev().find('input').focus();
      $(this).val('');
    }else
    {
      $(this).val('');

    }

  }else {
    $(this).val('');
    return false;
  }
})

$('body').on('click',".go_back_postal_code", function(){

  $(this).hide() ;
  $(this).siblings('ul.button_group.sp.js_postal_code').show();
  $(this).parents('.content').find('.shiping_found').hide();
  $(this).parents('.content').find('.shiping_not_found').hide()
  $(this).parents('.content').find('.postal_code_status').show()

  $(".js_postal_code input").val('');
  $(".js_postal_code input").eq(0).focus()

});


$('.HomeSlider').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  dots: false,
  centerMode: true,
  centerPadding: "40px"

});

$(document).on('click','.MobNext ',function(){
  $(".HomeSlider").slick('slickNext');
});
$(document).on('click','.MobPrev',function(){
  $(".HomeSlider").slick('slickPrev');
});

$(".get_quote_fields .get_quote_field").keyup(function(){
  $(this).removeAttr("style");
});


$("#verify").change(function(){
  console.log('sasa')
  $(this).parents(".error").removeClass('error');
});


$(".localization-form__select").click(function(){
  $(this).parents(".disclosure").find('#FooterLanguageList').toggleClass('active');
});

$(window).click(function() {
    var container = $(".disclosure");
    if (!container.is(event.target) && !container.has(event.target).length) {
        container.find('#FooterLanguageList').removeClass('active');  
      container.find('.localization-selector').attr('aria-expanded','false');
    }
});


$(".LanguageList_disclosure").focusout(function() {

let _self = this
  setTimeout(function(){

    $(_self).find('#FooterLanguageList').removeClass('active');
     $(_self).find('.localization-selector').attr('aria-expanded','false');
  }, 500);

  console.log('sassssssssa')
})

// function outsideClick(event, notelem)	{
//     notelem = $(notelem); // jquerize (optional)
//     // check outside click for multiple elements
//     var clickedOut = true, i, len = notelem.length;
//     for (i = 0;i < len;i++)  {
//         if (event.target == notelem[i] || notelem[i].contains(event.target)) {
//             clickedOut = false;
//         }
//     }
//     if (clickedOut) return true;
//     else return false;
// }

// window.addEventListener('click', function(e) {
//     var container = $(".disclosure");
//    if (outsideClick(e, container)) {
//    		// close modal
//    }
  
//   console.log('sasas')
// });


